import { Component, effect,inject } from '@angular/core';
import { FormBuilder, FormControl, FormGroup} from '@angular/forms';
import { LocalStorageService } from 'src/app/common/services/local-storage.service';
import { SharedSignalsService } from 'src/app/common/services/shared-signals.service';
import { TranslationService } from 'src/app/common/services/translation.service';


@Component({
  selector: 'taly-how-it-work',
  templateUrl: './how-it-work.component.html',
  styleUrls: ['./how-it-work.component.scss']
})
export class HowItWorkComponent {

  amountCtrl = new FormControl(100);

  transferSignal = inject(SharedSignalsService);
  textDirection: string;
  sliderAmount:any=[];
 
  constructor(public translationService: TranslationService, private storageService: LocalStorageService,private fb: FormBuilder) { 
    effect(() => { 
      setTimeout(() => {
      this.textDirection = this.transferSignal.textDirection();
      },1000) 
    });
  }

  ngOnInit(): void {
  }

}
